import type { GateSigningPersonId } from '../types/wizard.types';

export const GATE_SIGNING_PERSON_OPTIONS: Array<{ value: GateSigningPersonId; label: string }> = [
  { value: 'arkhiptsev', label: 'Архипцев Денис Владимирович' },
  { value: 'gordiychuk', label: 'Гордийчук Вадим Владимирович' },
  { value: 'balashov', label: 'Балашов Сергей Сергеевич' },
  { value: 'office', label: 'ОФИС (Шалеев А.Г.)' },
];

export function gateSigningPersonLabel(id: GateSigningPersonId): string {
  return GATE_SIGNING_PERSON_OPTIONS.find((o) => o.value === id)?.label ?? id;
}
